import type { HideToastsByTagAction, ToastAction } from "app/actions/toast_actions";
import { SHOW_TOAST, HIDE_TOAST, HIDE_TOASTS_BY_TAG } from "app/actions/toast_actions";
import type { IToast } from "app/components/React/Toast/types";

interface UiState {
    toasts: IToast[];
}

const DEFAULT_STATE: UiState = {
    toasts: [],
};

type ActionType = ToastAction | HideToastsByTagAction | { type: "" };

const uiReducers = (state: UiState = DEFAULT_STATE, action: ActionType): UiState => {
    switch (action.type) {
        case HIDE_TOAST:
            return {
                ...state,
                toasts: state.toasts.filter((toast: IToast) => toast.timestamp !== action.toast.timestamp),
            };
        case SHOW_TOAST:
            return {
                ...state,
                toasts: [...state.toasts, action.toast],
            };
        case HIDE_TOASTS_BY_TAG:
            return {
                ...state,
                toasts: state.toasts.filter((toast: IToast) => toast.tag !== action.tag),
            };
        default:
            return state;
    }
};

export default uiReducers;
